import React from 'react';
import {useTranslation} from 'react-i18next';
import Popup from '../../index';

function UninstalledPaidPopup () {

	const {t} = useTranslation();

	return (
		<Popup className="uninstalled-paid-popup p-4" confirmBtn={true}>
			<h2>{t('upgradeTemplateUninstalledPaidTitle')}</h2>
			<p dangerouslySetInnerHTML={{__html:t('upgradeTemplateUninstalledPaidText')}}/>
		</Popup>
	)
}

export default UninstalledPaidPopup;
